export const ANY = 'ANY';
export const SUPER_USER = 'SUPER_USER';
export const REGULAR_USER = 'REGULAR_USER';
export const FLOWITY_USER = 'FLOWITY_USER';
// export const OPERATOR = 'OPERATOR';
export const NON_ONBOARDED = 'NON_ONBOARDED';
